(function($, Global) {
    var FormNewsletterComponent = function(model) {
        this.model = model;
    }

    FormNewsletterComponent.prototype.initEvents = function() {
        this.publishers();
    }

    FormNewsletterComponent.prototype.publishers = function() {
        var self = this;

        $(document).on('submit', '.form-register-newsletter', function(e) {
            e.preventDefault();

            var $this = $(this);
            var data = $this.serializeJson();
            var $form = $this.closest('form');

            if ($('.page-newsletter').exists()) {
                $.Topic('loader-show').publish('.page');
            }

            if ($form.closest('.modal-content').exists()) {
                $.Topic('loader-show').publish($form.closest('.modal-content'));
            }

            self.model.subscribeNewsletter(data, $form, function (res) {
                $('#modalNewsletter').modal('hide');
                $.Topic('loader-hide').publish($form.closest('.modal-content'));
                if (res.data.html && data.Mode && data.Mode == "bandeau" && !$('.page-formulelalettre').exists()) {
                    $this.closest('.banner-lalettre-formule').replaceWith(res.data.html);
                } else if (res.data.redirect != null) {
                    Global.location.replace(res.data.redirect)
                }
            });
        });
    }

    Global.FormNewsletterComponent = FormNewsletterComponent;
}(jQuery, window));